import React, { FC } from 'react';

import Avatar from '@material-ui/core/Avatar';

import { IOfficer } from '../../../../store/player/clubs/store';

import { userPic } from '../../../../assets/images';

interface IProps {
  index: number;
  officer: IOfficer;
}

const OfficerAvatar: FC<IProps> = props => {
  const { index, officer } = props;

  return (
    <div className="officer-avatar" key={`officer-avatar-${index}`}>
      <Avatar
        className="officer-avatar__avatar override"
        src={officer.user.profile.image === null ? userPic : officer.user.profile.image}
      />

      <h3 className="officer-avatar__position">{officer.position}</h3>

      <h2 className="officer-avatar__name">{`${officer.user.firstName} ${
        officer.user.lastName
      }`}</h2>

      <p className="officer-avatar__email">
        <a href={`mailto:${officer.user.email}`} target="_blank" rel="noopener noreferrer">
          CONTACT INFO
        </a>
      </p>
    </div>
  );
};

export default OfficerAvatar;
